/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import WarningRoundedIcon from '@material-ui/icons/WarningRounded';
import { withRoomContext } from '../RoomContext';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './styles.css';
import GradientButton from './customMui/newButton/newButton';

function InputDeviceAccess(props)
{

	const [ hrerUrl, sethrefUrl ] = useState('');

	const {
		browser
	} = props;

	useEffect(() =>
	{
		if (browser.platform === 'desktop')
		{
			if (browser.name === 'firefox')
			{
				sethrefUrl('https://www.google.com/search?q=allow+camera+and+microphone+access+firefox');
			}
			else if (browser.name === 'chrome')
			{
				sethrefUrl('https://www.google.com/search?q=allow+camera+and+microphone+access+chrome');
			}
			else if (browser.name === 'microsoft edge')
			{
				sethrefUrl('https://www.google.com/search?q=Allow+camera+and+microphone+access+Microsoft+Edge');
			}
			else if (browser.name === 'safari')
			{
				sethrefUrl('https://www.google.com/search?client=safari&rls=en&q=allow+camera+and+microphone+safari');
			}
			else if (browser.name === 'opera')
			{
				sethrefUrl('https://www.google.com/search?q=Allow+camera+and+microphone+access+Opera+mobile');
			}

		}
		else if (browser.platform === 'mobile')
		{
			if (browser.name === 'chrome')
			{
				sethrefUrl('https://www.google.com/search?q=allow+camera+and+microphone+access+chrome');
			}
			else if (browser.name === 'microsoft edge')
			{
				sethrefUrl('https://www.google.com/search?q=Allow+camera+and+microphone+access+Microsoft+Edge');
			}
			else if (browser.name === 'safari')
			{
				sethrefUrl('https://www.google.com/search?client=safari&rls=en&q=allow+camera+and+microphone+safari');
			}
			else if (browser.name === 'opera')
			{
				sethrefUrl('https://www.google.com/search?q=Allow+camera+and+microphone+access+Opera+mobile');
			}
		}
	}, []);

	return (
		<Dialog
			open={props.open}
			onClose={() => (browser.os !== 'macos' && browser.os !== 'ios') && props.handleClose()}
			className='dialogContent'
		>
			<DialogContent>
				<div className='flexCol'>
					<div className='flexRow alignCntr pdngLSM'>
						<WarningRoundedIcon style={{ color: 'red' }} />
						<h3 className='pdngLSM '>
							Permissions denied.
						</h3>
					</div>
					<div className='flexCol '>
						{browser.name === 'chrome' &&
						<span className='pdngXS'>Under Chrome settings, navigate to Privacy and Security &gt; Site Settings &gt; Permissions. Select Microphone, provide permission and reload this application.</span>
						// <span className='pdngXS'>Camera and microphone access required. Enable them in address bar in web browsers and for mobile app click the link below.</span>
						}
						{browser.name === 'firefox' &&
						<span className='pdngXS'>Under Firefox settings, navigate to Privacy and Security &gt; Permissions &gt; Camera, Microphone provide permission and reload this application.</span>
						// <span className='pdngXS'>Camera and microphone access required. Enable them in address bar in web browsers and for mobile app click the link below.</span>
						}
						{browser.name === 'safari' && browser.platform !== 'mobile' &&
						<span className='pdngXS'>Under Safari settings, navigate to Websites &gt; Camera, Microphone provide permission and reload this application.</span>
						}
						{browser.name === 'safari' && browser.platform === 'mobile' &&
						<span className='pdngXS'>Under Safari settings, navigate to Websites &gt; Camera, Microphone provide permission and reload this application.</span>
						}
						<div className='flexRow'>
							{browser.name === 'safari' && browser.platform === 'desktop' &&
							<a className='helpLink' target='_blank' href='https://www.google.com/search?client=safari&rls=en&q=allow+camera+and+microphone+safari' rel='noreferrer'>Click here for {browser.platform === 'desktop' ? browser.name : `${browser.platform} app`}</a>
							}
							{browser.name === 'safari' && browser.platform === 'mobile' &&
							<a className='helpLink' target='_blank' href='https://www.google.com/search?client=safari&rls=en&q=allow+camera+and+microphone+safari' rel='noreferrer'>Click here for ios app</a>
							}
							{browser.name !== 'safari' &&
							<a className='helpLink' target='_blank' href={hrerUrl && hrerUrl} rel='noreferrer'>Click here for {browser.platform === 'desktop' ? browser.name : `${browser.platform} app`}</a>
							}
						</div>
					</div>

				</div>
			</DialogContent>
			<DialogActions>
				<Button disableElevation
					// variant='outlined'
					onClick={() => props.handleClose()} color='primary'
				>
					Continue
				</Button>
				<GradientButton disableElevation variant='contained'
					onClick={() => { props.handleClose(); window.location.reload(true); }}
					color='primary'
				>
					Reload
				</GradientButton>
			</DialogActions>
		</Dialog>
	);
}

InputDeviceAccess.propTypes =
{
	browser     : PropTypes.any,
	open        : PropTypes.bool,
	handleClose : PropTypes.func,
	type        : PropTypes.string

};

function mapStateToProps(state)
{
	return ({
		browser : state.me.browser
		// isMobile  : state.me.browser.platform === 'mobile',
		// istablet  : state.me.browser.platform === 'tablet',
		// isDesktop : state.me.browser.platform === 'desktop',
		// isIos     : state.me.browser.os === 'ios',
		// isMacos   : state.me.browser.os === 'macos',
		// isWindows : state.me.browser.os === 'windows',
		// isAndroid : state.me.browser.os === 'android',
		// isLinux   : state.me.browser.os === 'linux',
		// isSafari  : state.me.browser.name === 'safari',
		// isChrome  : state.me.browser.name === 'chrome',
		// isEdge    : state.me.browser.name === 'edge',
		// isFirefox : state.me.browser.name === 'firefox',
		// isOpera   : state.me.browser.name === 'opera'

	});
}

export default withRoomContext(connect(
	mapStateToProps,
	null,
	null,
	{
		areStatesEqual : (next, prev) =>
		{
			return (
				prev.room.backgroundOpen === next.room.backgroundOpen &&
				prev.me.browser.name === next.me.browser.name
			);
		}
	}
)(InputDeviceAccess));